import { useState } from "react";
import { groupApi } from "../api/group.service";
import { MultiMoveAttendantPayload } from "../types";

export const useMoveMultiAttendant = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (
    source_group_id: string,
    payload: MultiMoveAttendantPayload
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.moveMultiMember(
        source_group_id,
        payload
      );

      return {
        success: true,
        message: response?.data?.message,
        success_count: response?.data?.data?.success_count,
        error_count: response?.data?.data?.error_count,
        error: response?.data?.data?.errors || null,
      };
    } catch (err: any) {
      console.log("Move multi attendant failed:", err);

      return {
        success: false,
        message: err?.response?.data?.message || "Something wrong",
        success_count: 0,
        error_count:
          err?.response?.data?.error?.serializer?.errors?.length || 0,
        error: err?.response?.data?.error?.serializer?.errors,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
